import { useState } from "react";
import TotalOrderOverview from "./TotalOrderOverview"

interface CardGroupProps {
  filterParams: any;
}

const  ChartGroup: React.FC<CardGroupProps> = ({ filterParams }) => {
  const [orderOverview, setOrderOverview] = useState<any>({});

 
  
  return (
    <section className="flex flex-col md:flex-row pb-5 gap-5">
      <TotalOrderOverview className="md:w-[100%]" />
      {/* <StockUnit className="md:w-[40%]" /> */}
    </section>
  );
}

export default ChartGroup